import axios from 'axios';
import { API_URL } from '../config/api';

/**
 * Candidate Service
 * 
 * What this does:
 * - Makes API calls for candidate operations
 * - Create, read, update, delete candidates
 * - Search functionality
 */

const API_BASE = API_URL;

const candidateService = {
  
  /**
   * Create new candidate
   */
  create: async (candidateData) => {
    const response = await axios.post(`${API_BASE}/candidates`, candidateData);
    return response.data;
  },

  /**
   * Get all candidates
   */
  getAll: async () => {
    const response = await axios.get(`${API_BASE}/candidates`);
    return response.data;
  },

  /**
   * Get candidate by ID
   */
  getById: async (candidateId) => {
    const response = await axios.get(`${API_BASE}/candidates/${candidateId}`);
    return response.data;
  },

  /**
   * Get candidate with all pipelines
   */
  getWithPipelines: async (candidateId) => {
    const response = await axios.get(`${API_BASE}/candidates/${candidateId}/pipelines`);
    return response.data;
  },

  /**
   * Search candidates
   */
  search: async (searchTerm) => {
    const response = await axios.get(`${API_BASE}/candidates/search`, {
      params: { q: searchTerm }
    });
    return response.data;
  },

  /**
   * Update candidate
   */
  update: async (candidateId, updates) => {
    const response = await axios.put(`${API_BASE}/candidates/${candidateId}`, updates);
    return response.data;
  },

  /**
   * Delete candidate
   */
  delete: async (candidateId) => {
    await axios.delete(`${API_BASE}/candidates/${candidateId}`);
  },

  /**
   * Get candidate statistics
   */
  getStatistics: async (candidateId) => {
    const response = await axios.get(`${API_BASE}/candidates/${candidateId}/statistics`);
    return response.data;
  },

  /**
   * Add candidate to pipeline
   */
  addToPipeline: async (candidateId, pipelineId, stageId, priority = 'medium') => {
    const response = await axios.post(
      `${API_BASE}/candidates/${candidateId}/add-to-pipeline`,
      { pipeline_id: pipelineId, stage_id: stageId, priority }
    );
    return response.data;
  }
};

export default candidateService;
